import request from 'utils/axios/service';
import { endpoints } from '../constants'

class LoginService {
    async loginApi(req) {
        return await request.post(endpoints.LOGIN, req);
    }
    async employeeVerify(req){
        return await request.post(endpoints.EMPLOYEE_VERIFY, req)
    }
    async otpVerify(req){
        return await request.post(endpoints.VERIFY_OTP, req)
    }
    async resendOTP(req){
        return await request.post(endpoints.RESEND_OTP, req)
    }
    async refreshToken(req){
        return await request.post(endpoints.REFRESH_TOKEN, req)
    }
    async logoutEmployee(){
        return await request.get(endpoints.LOGOUT_EMPLOYEE)
    }
    async employeeDetails(){
        return await request.get(endpoints.EMPLOYEE_DETAILS)
    }

    async registerEmployee(){
        return await request.get(endpoints.REGISTER_EMPLOYEE)
    }
}

export default LoginService;
